import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToolbarModule } from '@components/toolbar';
import { ButtonModule } from '@components/button';
import { DirectivesModule } from '@directives/directives.module';
import { PopUpModule } from '@components/pop-up';
import { ProductCarouselModule } from '@shared/product-carousel/product-carousel.module';
import { RouterModule } from '@angular/router';
import { SwiperModule } from 'swiper/angular';
import { CsIconModule } from '@components/icon';
import { VideoPlayerModule } from '@components/video-player/video-player.module';
import { LoadingModule } from '@components/loading';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { IncompleChatSheetModule } from '@shared/bottom-sheet-layouts/incomplete-chat/incomplete-chat.module';
import { HomePageSheetModule } from '@shared/bottom-sheet-layouts/homepage-bottom-sheet/home-page-bottom-sheet.module';
import { FollowUpChatSheetModule } from '@shared/bottom-sheet-layouts/followup-chat/followup-chat-sheet.module';
import { PrivacyPolicySheetModule } from '@shared/bottom-sheet-layouts/privacy-policy/privacy-policy-sheet.module';
import { CureskinCashSheetModule } from '@shared/bottom-sheet-layouts/cureskin-cash-sheet/cureskin-cash.module';
import { HomeBannersModule } from '@shared/home-banners/home-banners.module';
import { AnytimeFollowupModule } from '@shared/bottom-sheet-layouts/anytime-followup/anytime-followup.module';
import { HairThinningBannerModule } from '@shared/home-banners/hair-thinning/hair-thinning.module';
import { HairFallMaleBannerModule } from '@shared/home-banners/control-hair-fall-male/hair-fall-male.module';
import { HairFallBannerModule } from '@shared/home-banners/hair-fall/hair-fall-banner.module';
import { HairDandruffBannerRegimenModule } from '@shared/home-banners/hair-dandruff-regimen/hair-dandruff-regimen.module';
import { TestimonialModule } from 'client/app/testimonial/testimonial.module';
import { CAudioModule } from '@shared/c-audio/c-audio.module';
import { TakePhotoBannerModule } from '@shared/take-photo-banner/take-photo-banner.module';
import { ComparisonSliderModule } from '@shared/comparison-slider/comparison-slider.module';
import { RegimenOfferProductBannerModule } from '@shared/regimen-offer-product-banner/regimen-offer-product-banner.module';
import { BannerWrapperComponent } from '@components/banner-wrapper';
import { SwiperWrapperComponent } from '@components/swiper-wrapper';
import UserHomeComponent from './user-home.component';
import { UserProfileModule } from '../../../user-profile/user-profile.module';
import { BannerScrollbarModule } from './banner-scrollbar/banner-scrollbar.module';
import { DietBannerModule } from './diet-banner/diet-banner.module';
import { OrderDetailBannerModule } from './order-details-banner/order-details-banner.module';
import { NPSBannerModule } from './n-p-s-banner/n-p-s-banner.module';
import { ReportGettingReadyComponent } from './level-two-banners/report-getting-ready/report-getting-ready.component';
import { FollowUpQuestionsWidgetComponent } from '@shared/follow-up-questions-widget/follow-up-questions-widget.component';
import { ReportIsReadyComponent } from './level-two-banners/report-is-ready/report-is-ready.component';
import { RequestingPhotoComponent } from './level-two-banners/requesting-photo/requesting-photo.component';
import { LastLevelBannerComponent } from './last-level-banner/last-level-banner.component';
import { CrossRegimenBannerV2Component } from './cross-regimen-banner-v2/cross-regimen-banner-v2.component';
import { RequestCallBannerComponent } from '@shared/pending-call-banners/request-call-banner/request-call-banner.component';
import { CallScheduledBannerComponent } from '@shared/pending-call-banners/call-scheduled-banner/call-scheduled-banner.component';
import { CallCompletedBannerComponent } from '@shared/pending-call-banners/call-completed-banner/call-completed-banner.component';
import {
  DoctorCallUnsuccessfulBannerComponent
} from '@shared/pending-call-banners/doctor-call-unsuccessful-banner/doctor-call-unsuccessful-banner.component';
import { UserQueryChatBannerComponent } from "@shared/user-query-chat-banner/user-query-chat-banner.component";
import {
    NotificationPermissionPopupComponent
} from './notification-permission/notification-permission-popup/notification-permission-popup.component';
import {
  NotificationBannerComponent
} from './notification-permission/notification-permission-banner/notification-permission-banner.component';

import { RecentlyViewedProductsComponent } from '@shared/recently-viewed-products/recently-viewed-products.component';
import { RecommendedProductsComponent } from '@shared/recommended-products/recommended-products.component';
import { SelfCheckupBannerComponent } from '@shared/self-checkup-image-banner/self-checkup-banner.component';
import { NutraPushBannerComponent } from './nutra-push/nutra-push-banner/nutra-push-banner.component';
import { DoctorCheckupReminderBannerComponent } from 'client/app/user/user-view/user-home/doctor-checkup-reminder-banner/doctor-checkup-reminder-banner.component';
import { ProcessingBannerComponent } from '@shared/home-banners/processing-banner/processing-banner.component';
import { BentoGridComponent } from '@components/bento-grid/bento-grid.component';
import { BentoGridItemDirective } from '@directives/bento-grid-directive/bento-grid-item.directive';
import { ActionWithImageBannerComponent } from '@components/action-with-image-banner/action-with-image-banner.component';
import { IncompleteBannerComponent } from './incomplete-banner/incomplete-banner.component';
import { RegimenExpiryBannerComponent } from '@shared/home-banners/regimen-expiry-banner/regimen-expiry-banner.component';
import { RegimenExpiredBannerComponent } from '@shared/home-banners/regimen-expired-banner/regimen-expired-banner.component';
import { OrderDeliveredComponent } from '@shared/home-banners/order-delivered/order-delivered.component';
import { GamificationBannerComponent } from './gamification-banner/gamification-banner.component';
import { GamificationRewardBannerComponent } from './gamification-reward-banner/gamification-reward-banner.component';
import { GamificationScratchCardComponent } from './gamification-scratch-card/gamification-scratch-card.component';
import { MoneyBackGuaranteeBannerComponent } from '@shared/money-back-guarentee/money-back-guarantee-banner.component';
import {ButtonCtaComponent} from '@components/button-cta/button-cta.component';
import { ShopNavigateBannerComponent } from './shop-navigate-banner/shop-navigate-banner.component';
import { AcqShopProductsBannerComponent } from './acq-shop-products-banner/acq-shop-products-banner.component';
import { ActiveCheckupBottomsheetComponent } from 'client/app/user-checkup/active-checkup-bottomsheet/active-checkup-bottomsheet.component';
import { RegimenReorderBannerComponent } from '@shared/regimen-reorder-banner/regimen-reorder-banner.component';
import { SubmitDefualtAnswersBannerComponent } from '@shared/home-banners/submit-defualt-answers-banner/submit-defualt-answers-banner.component';
import { ExploreSliderBannerComponent } from "@shared/home-banners/explore-slider-banner/explore-slider-banner.component";
import { QuizBannerV2Component } from '@shared/home-banners/quiz-banner-v2/quiz-banner-v2.component';
import { MoreForYouComponent } from '@shared/home-banners/more-for-you/more-for-you.component';
import { DietGuidanceBannerComponent } from '@shared/diet-guidance-banner/diet-guidance-banner.component';
import { RestockBannerComponent } from '@shared/home-banners/restock-banner/restock-banner.component';
import { LanguageBannerComponent } from '@shared/home-banners/language-banner/language-banner.component';
import { IsotretinoinConsentPendingComponent } from '@shared/home-banners/isotretinoin-consent-pending/isotretinoin-consent-pending.component';
import { InvestigationStripComponent } from '@shared/home-banners/investigation-strip/investigation-strip.component';
import { InvestigationSheetComponent } from '@shared/bottom-sheet-layouts/investigation-sheet/investigation-sheet.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    VideoPlayerModule,
    DirectivesModule,
    VideoPlayerModule,
    ToolbarModule,
    ButtonModule,
    PopUpModule,
    UserProfileModule,
    ProductCarouselModule,
    BannerScrollbarModule,
    DietBannerModule,
    OrderDetailBannerModule,
    SwiperModule,
    CsIconModule,
    LoadingModule,
    TestimonialModule,
    NPSBannerModule,
    MatBottomSheetModule,
    IncompleChatSheetModule,
    FollowUpChatSheetModule,
    CAudioModule,
    HomePageSheetModule,
    PrivacyPolicySheetModule,
    CureskinCashSheetModule,
    HomeBannersModule,
    AnytimeFollowupModule,
    HairThinningBannerModule,
    HairFallMaleBannerModule,
    HairFallBannerModule,
    HairDandruffBannerRegimenModule,
    RegimenOfferProductBannerModule,
    DoctorCheckupReminderBannerComponent,
    ReportGettingReadyComponent,
    FollowUpQuestionsWidgetComponent,
    ReportIsReadyComponent,
    RequestingPhotoComponent,
    ComparisonSliderModule,
    TakePhotoBannerModule,
    LastLevelBannerComponent,
    CrossRegimenBannerV2Component,
    RequestCallBannerComponent,
    CallScheduledBannerComponent,
    CallCompletedBannerComponent,
    DoctorCallUnsuccessfulBannerComponent,
    RecentlyViewedProductsComponent,
    UserQueryChatBannerComponent,
    NotificationPermissionPopupComponent,
    NotificationBannerComponent,
    SelfCheckupBannerComponent,
    NutraPushBannerComponent,
    ProcessingBannerComponent,
    BentoGridComponent,
    BentoGridItemDirective,
    ActionWithImageBannerComponent,
    IncompleteBannerComponent,
    RegimenExpiryBannerComponent,
    RegimenExpiredBannerComponent,
    OrderDeliveredComponent,
    GamificationBannerComponent,
    GamificationRewardBannerComponent,
    GamificationScratchCardComponent,
    MoneyBackGuaranteeBannerComponent,
    ButtonCtaComponent,
    ShopNavigateBannerComponent,
    AcqShopProductsBannerComponent,
    ActiveCheckupBottomsheetComponent,
    RegimenReorderBannerComponent,
    ExploreSliderBannerComponent,
    SubmitDefualtAnswersBannerComponent,
    QuizBannerV2Component,
    MoreForYouComponent,
    DietGuidanceBannerComponent,
    RestockBannerComponent,
    LanguageBannerComponent,
    BannerWrapperComponent,
    SwiperWrapperComponent,
    IsotretinoinConsentPendingComponent,
    RecommendedProductsComponent,
    InvestigationStripComponent,
    InvestigationSheetComponent,
  ],
  declarations: [UserHomeComponent],
  exports: [UserHomeComponent],
})
export class UserHomeModule { }
